import { RepAccessTypes } from '@/modules/tenantProjects/contractors/consts'

export function getContactChip (isContractorAdmin = false) {
  return {
    TenantProjectAccount: {
      contactFirstName: '',
      contactLastName: '',
      phone: '',
      altPhone: '',
      accessType: RepAccessTypes.NORMAL,
      isContractorAdmin,
    },
    username: '',
  }
}

export function checkEmptyAccount (account) {
  const keys = ['contactFirstName', 'contactLastName', 'phone', 'altPhone']
  return account.username === '' &&
        (!account.TenantProjectAccount ||
          keys.every(key => account.TenantProjectAccount[key] === ''))
}
